import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import Hab from '../layouts/Habitantes';
import clienteAxios from '../../config/clientAxios';

const DEFAULT_CIFRAS = {
    habitantes_cifra: 0,
    habitantes_descripcion: '',
    empleos_cifra: 0,
    empleos_descripcion: '',
    superficie_cifra: 0,
    superficie_descripcion: '',
    pea_cifra: 0,
    pea_descripcion: ''
};

const Habitantes = () => {

    const [cifras, setCifras] = useState(DEFAULT_CIFRAS);

    useEffect(() => {
        const getCifras = async () => {
            await clienteAxios.get(`banner/cifras`, { timeout: 30000 })
                .then(response => {
                    const nextCifras = response.data && response.data.cifras
                        ? response.data.cifras
                        : {};

                    setCifras({
                        ...DEFAULT_CIFRAS,
                        ...nextCifras
                    });
                }).catch(error => {
                    console.error(error);
                    setCifras(DEFAULT_CIFRAS);
                });
        }
        getCifras();
    }, []);

    return (
        <div className='shadow mb-2 rounded' style={{ background: `#730E10`, marginBottom: `1.45rem`, }}>
            <br></br>
            { <Row>
                <Hab
                    cifra={cifras.habitantes_cifra}
                    title={cifras.habitantes_descripcion}
                />
                <Hab
                    cifra={cifras.empleos_cifra}
                    title={cifras.empleos_descripcion}
                />
                <Hab
                    cifra={cifras.superficie_cifra}
                    title={cifras.superficie_descripcion}
                />
                <Hab
                    cifra={cifras.pea_cifra}
                    title={cifras.pea_descripcion}
                />
            </Row>}
        </div>
    );
}
export default Habitantes;
